module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldCondIt.5129756.eot";